export enum WorkArea {
  ENGINEERING = 'ENGINEERING',
  HR_PEOPLE = 'HR_PEOPLE',
  SALES = 'SALES',
  MARKETING = 'MARKETING',
  SUPPORT_CS = 'SUPPORT_CS',
  FINANCE = 'FINANCE',
  OPERATIONS = 'OPERATIONS',
  LEGAL = 'LEGAL',
  FOUNDER_LEADERSHIP = 'FOUNDER_LEADERSHIP',
}
